export const legalPath = "/legal"
